import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import { handleVideo, handleLive } from '../datas/famous-doctor-hall'
export default {
  createdVideo (ctx, data) {
    return fetch.createdVideo(data).then(res => {
      return res
    })
  },
  updateVideo (ctx, data) {
    return fetch.updateVideo(data).then(res => {
      return res
    })
  },
  getVideoList (ctx, data) {
    return fetch.getVideoList(data).then(res => {
      res.data.forEach(item => {
        handleVideo(item)
      })
      return getTotalNumber(res)
    })
  },
  deteleVideo (ctx, data) {
    return fetch.deteleVideo(data).then(res => {
      return res
    })
  },
  getVideoDetail (ctx, data) {
    return fetch.getVideoDetail(data).then(res => {
      handleVideo(res.data)
      return res
    })
  },
  videoOperation (ctx, data) {
    return fetch.videoOperation(data).then(res => {
      return res
    })
  },
  createdLive (ctx, data) {
    return fetch.createdLive(data).then(res => {
      return res
    })
  },
  updateLive (ctx, data) {
    return fetch.updateLive(data).then(res => {
      return res
    })
  },
  getLiveList (ctx, data) {
    return fetch.getLiveList(data).then(res => {
      res.data.forEach(item => {
        handleLive(item)
      })
      return getTotalNumber(res)
    })
  },
  deteleLive (ctx, data) {
    return fetch.deteleLive(data).then(res => {
      return res
    })
  },
  getLiveDetail (ctx, data) {
    return fetch.getLiveDetail(data).then(res => {
      handleLive(res.data)
      return res
    })
  }
}
